import { render, staticRenderFns } from "./DigitalHumanTipDialog.vue?vue&type=template&id=9fb04b32"
import script from "./DigitalHumanTipDialog.vue?vue&type=script&lang=js"
export * from "./DigitalHumanTipDialog.vue?vue&type=script&lang=js"
import style0 from "./DigitalHumanTipDialog.vue?vue&type=style&index=0&id=9fb04b32&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports